/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Utils.Object
 */

module.exports = {

    Clone: require('./Clone'),
    Extend: require('./Extend'),
    GetAdvancedValue: require('./GetAdvancedValue'),
    GetFastValue: require('./GetFastValue'),
    GetMinMaxValue: require('./GetMinMaxValue'),
    GetValue: require('./GetValue'),
    HasAll: require('./HasAll'),
    HasAny: require('./HasAny'),
    HasValue: require('./HasValue'),
    IsPlainObject: require('./IsPlainObject'),
    Merge: require('./Merge'),
    MergeRight: require('./MergeRight')

};



//////////////////
// WEBPACK FOOTER
// ./utils/object/index.js
// module id = 982
// module chunks = 0